(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const artifactText = 'EMPTY DOM REMOVE PROTECTOR';
  let revealObserver;
  let parallaxNodes = [];
  let parallaxFrame;

  document.documentElement.classList.add('aurvex-motion-ready');

  function cleanArtifacts(root = document.body) {
    if (!root) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) {
      if (walker.currentNode.textContent?.trim() === artifactText) nodes.push(walker.currentNode);
    }
    nodes.forEach((node) => { node.textContent = ''; });
  }

  function setupReveals(root = document) {
    const nodes = root.querySelectorAll?.('[data-aurvex-reveal]:not([data-aurvex-reveal-ready])') || [];

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      nodes.forEach((node) => {
        node.dataset.aurvexRevealReady = 'true';
        node.classList.add('is-visible');
      });
      return;
    }

    revealObserver ||= new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.13, rootMargin: '0px 0px -5% 0px' });

    nodes.forEach((node) => {
      node.dataset.aurvexRevealReady = 'true';
      revealObserver.observe(node);
    });
  }

  function setupSliders(root = document) {
    const sliders = root.querySelectorAll?.('[data-aurvex-slider]:not([data-aurvex-slider-ready])') || [];

    sliders.forEach((slider) => {
      const track = slider.querySelector('[data-aurvex-slider-track]');
      const previous = slider.querySelector('[data-aurvex-slider-prev]');
      const next = slider.querySelector('[data-aurvex-slider-next]');
      if (!track) return;

      const move = (direction) => {
        const item = track.firstElementChild;
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        const distance = item ? item.getBoundingClientRect().width + gap : track.clientWidth * 0.82;
        track.scrollBy({ left: distance * direction, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      };

      previous?.addEventListener('click', () => move(-1));
      next?.addEventListener('click', () => move(1));
      slider.dataset.aurvexSliderReady = 'true';
    });
  }

  function updateParallax() {
    parallaxFrame = undefined;
    if (reduceMotion.matches) return;

    const viewport = window.innerHeight;
    parallaxNodes.forEach((node) => {
      const rect = node.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > viewport) return;
      const progress = (rect.top + rect.height * 0.5 - viewport * 0.5) / viewport;
      node.style.setProperty('--ax-parallax-y', `${Math.max(-18, Math.min(18, progress * -24)).toFixed(1)}px`);
    });
  }

  function setupParallax(root = document) {
    if (reduceMotion.matches) return;
    const fresh = root.querySelectorAll?.('[data-aurvex-parallax]:not([data-aurvex-parallax-ready])') || [];
    fresh.forEach((node) => {
      node.dataset.aurvexParallaxReady = 'true';
      parallaxNodes.push(node);
    });
    updateParallax();
  }

  function onScroll() {
    if (parallaxFrame) return;
    parallaxFrame = requestAnimationFrame(updateParallax);
  }

  function initialize(root = document) {
    setupReveals(root);
    setupSliders(root);
    setupParallax(root);
    cleanArtifacts(root === document ? document.body : root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  const lateArtifactCleanup = new MutationObserver(() => cleanArtifacts(document.body));
  if (document.body) {
    lateArtifactCleanup.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => lateArtifactCleanup.disconnect(), 5000);
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      lateArtifactCleanup.observe(document.body, { childList: true, subtree: true });
      window.setTimeout(() => lateArtifactCleanup.disconnect(), 5000);
    }, { once: true });
  }
})();


(() => {
  if (window.aurvexVisualV15) return;
  window.aurvexVisualV15 = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const active = new Set(), observed = new WeakSet();
  const clamp = n => Math.max(0, Math.min(1, n));
  let frame = 0;
  const selector = '[data-ax-chapter],.axh-sell,.axh-hero,.axe';
  const buttonSelector = '#MainContent[data-ax-world="product"] .add-to-cart-button,#MainContent[data-ax-world="product"] .axed__btn,#MainContent[data-ax-world="product"] .axpp-pair__add';
  function sweep(button) {
    if (!button || button.disabled || reduced.matches) return;
    button.classList.remove('ax-button-sweep');
    requestAnimationFrame(() => requestAnimationFrame(() => {
      if (button.isConnected && !reduced.matches) button.classList.add('ax-button-sweep');
    }));
  }
  function update() {
    frame = 0;
    const vh = innerHeight;
    active.forEach(el => {
      if (!el.isConnected) { active.delete(el); return; }
      const box = el.getBoundingClientRect();

      const image = el.querySelector('.axoc__visual');
      if (image) {
        const ir = image.getBoundingClientRect();
        const imageProgress = clamp((vh - ir.top) / (vh + ir.height));
        el.style.setProperty('--ax-image-y', reduced.matches ? '0px' : `${(5 - imageProgress * 10).toFixed(2)}px`);
        const holder = el.querySelector('[data-ax-price-drop]');
        if (holder) {
          // Keep the complete hanger hidden until the image edge crosses 66% of the viewport.
          const fall = reduced.matches ? 1 : clamp((vh * .66 - ir.bottom) / (vh * .34));
          const eased = fall * fall * (3 - 2 * fall);
          holder.style.setProperty('--ax-drop-progress', String(eased));
          holder.style.setProperty('--ax-drop-y', `${-148 * (1 - eased)}px`);
          holder.style.setProperty('--ax-drop-visible', fall > 0 ? 'visible' : 'hidden');
        }
      }
      if (el.matches('.axh-sell')) {
        const reveal = reduced.matches ? 0 : clamp((vh * .9 - box.top) / (vh * .7));
        el.style.setProperty('--ax-type-reveal', `${(reveal * 100).toFixed(2)}%`);
        el.style.setProperty('--ax-type-slide', reduced.matches ? '0px' : `${(10 - reveal * 20).toFixed(2)}px`);
      }
    });
  }
  function schedule() { if (!frame) frame=requestAnimationFrame(update); }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(e => e.isIntersecting ? active.add(e.target) : active.delete(e.target));
    schedule();
  },{rootMargin:'160px 0px'}) : null;
  const buttonObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (!e.isIntersecting) return;
      sweep(e.target);
      buttonObserver.unobserve(e.target);
    });
  },{threshold:.8}) : null;
  function init() {
    document.querySelectorAll(selector).forEach(el => {
      if(observed.has(el)) return;
      observed.add(el);active.add(el);observer?.observe(el);
    });
    document.querySelectorAll(buttonSelector).forEach(button => {
      if (button.dataset.axSweepReady) return;
      button.dataset.axSweepReady='true';
      buttonObserver?.observe(button);
    });
    document.documentElement.dataset.axMotion=reduced.matches?'reduced':'v15';
    schedule();
  }
  document.addEventListener('pointerover',event=>sweep(event.target.closest?.(buttonSelector)));
  document.addEventListener('focusin',event=>sweep(event.target.closest?.(buttonSelector)));
  document.addEventListener('click',event=>sweep(event.target.closest?.(buttonSelector)),true);
  document.addEventListener('animationend',event=>{
    if(event.animationName==='ax12-button-sweep') event.target.classList.remove('ax-button-sweep');
  });
  document.addEventListener('cart:update',event=>{
    if(event.detail?.data?.didError) return;
    const cart=document.querySelector('.header-actions__cart-icon');
    if(cart && !reduced.matches) cart.animate([{transform:'scale(1)'},{transform:'scale(1.16)'},{transform:'scale(1)'}],{duration:430,easing:'ease-out'});
  });
  reduced.addEventListener('change',()=>{
    if(reduced.matches) {
      document.querySelectorAll('.ax-button-sweep').forEach(b=>b.classList.remove('ax-button-sweep'));
    }
    document.querySelectorAll(selector).forEach(el=>active.add(el));
    document.documentElement.dataset.axMotion=reduced.matches?'reduced':'v15';
    schedule();
  });
  addEventListener('scroll',schedule,{passive:true});
  addEventListener('resize',schedule,{passive:true});
  addEventListener('pageshow',init);
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('variant:update',init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();

(() => {
  const setups = new Map();
  function setup() {
    setups.forEach((state,grid) => {
      if (!grid.isConnected) { state.observer?.disconnect();cancelAnimationFrame(state.frame);setups.delete(grid); }
    });
    document.querySelectorAll('#MainContent[data-ax-world="index"] .axoc__grid').forEach(grid => {
      if (setups.has(grid)) return;
      const state = { frame:0,observer:null };
      const paint = () => {
        state.frame=0;
        const base=grid.getBoundingClientRect();
        const cards=[...grid.querySelectorAll('.axoc__item')];
        if (!cards.length || base.height <= 0) return;
        const stops=[];
        cards.forEach(card => {
          const rect=card.getBoundingClientRect();
          const css=getComputedStyle(card);
          const from=css.getPropertyValue('--ax-from').trim();
          const to=css.getPropertyValue('--ax-to').trim();
          const height=parseFloat(getComputedStyle(card,'::after').height);
          if (!from || !to || !Number.isFinite(height)) return;
          const start=rect.bottom-base.top-height;
          stops.push(`${from} ${Math.max(0,rect.top-base.top).toFixed(3)}px`);
          for(let i=0;i<=24;i++) {
            const t=i/24,ease=t*t*(3-2*t);
            stops.push(`color-mix(in srgb,${from} ${(100*(1-ease)).toFixed(4)}%,${to}) ${(start+t*height).toFixed(3)}px`);
          }
        });
        if (!stops.length) return;
        grid.style.backgroundImage=`linear-gradient(180deg,${stops.join(',')})`;
        grid.dataset.axContinuous='true';
      };
      const schedule=() => { cancelAnimationFrame(state.frame);state.frame=requestAnimationFrame(paint); };
      if ('ResizeObserver' in window) {
        state.observer=new ResizeObserver(schedule);
        state.observer.observe(grid);
        grid.querySelectorAll('.axoc__item').forEach(card=>state.observer.observe(card));
      }
      setups.set(grid,state);paint();
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',setup,{once:true});else setup();
  document.addEventListener('shopify:section:load',setup);
  document.addEventListener('shopify:section:unload',setup);
})();
